export const EXCMCUSTOMFIELDVALUE_SHOW_RESET = 'EXCMCUSTOMFIELDVALUE_SHOW_RESET'
export const EXCMCUSTOMFIELDVALUE_SHOW_SET_ERROR = 'EXCMCUSTOMFIELDVALUE_SHOW_SET_ERROR'
export const EXCMCUSTOMFIELDVALUE_SHOW_SET_RETRIEVED = 'EXCMCUSTOMFIELDVALUE_SHOW_SET_RETRIEVED'
export const EXCMCUSTOMFIELDVALUE_SHOW_TOGGLE_LOADING = 'EXCMCUSTOMFIELDVALUE_SHOW_TOGGLE_LOADING'
